import React from "react";

import {
  Form,
  FormElement,
  FormValidator,
  CustomTextControl,
  BaseReactComponent,
  FormSubmitButton,
  SelectControl,
} from "../../utils/form";

import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "../../utils/hoc/withRouter";
import { CustomModal, Spinner, SelectKeywords } from "../common";
import { addSubCategoryApi, updateSubCategoryApi, getCategoryApiForsub, getKeywordNameApi } from "./Api";
import { toast } from "react-toastify";
import { isModuleExist, MODULE_ID_MAP } from "../../utils/Constant";
import { getAllSsoApi, getAllSsoPartnersApi } from "../sso/Api";
import { isPartnerAllowed } from "../../utils/ReusableFunctions";

class ContentTypeForm extends BaseReactComponent {
  constructor(props) {
    super(props);
    const data = props.editData || null;
    const AccesData = isModuleExist(MODULE_ID_MAP.ContentMasterSubCategory);
    let partners = this.loadDefaultPartners(AccesData)
    if (data?.partners?.list) {
      partners = data?.partners
    }

    this.state = {
      AccessData: AccesData,
      partners,
      subCategoryName: data?.subCategoryName || "",
      categoryName: data?.category?.uuid || "",
      AllCategeory: [],
      options: [],
      keywords: data?.keywords ? data.keywords.split(",").map(item => item.trim()).filter(Boolean) : [],
      keywordOption: [],
      search: "",
      isAddContent: true,

      resLoading: false,
    };
  }


  componentDidMount() {
    // let fromsubCategory=true;
    getCategoryApiForsub(this);
    console.log(this.state.AllCategeory)
    getAllSsoPartnersApi(this);
    this.props.getKeywordNameApi(this);
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.search !== prevState.search) {
      this.props.getKeywordNameApi(this);
    }
  }
  keywordsChangeHandler = (info) => {
    this.setState({ search: info })
  }

  onValidSubmit = () => {
    this.setState({ resLoading: true })
    let data = {
      "data": {
        "subCategoryName": this.state.subCategoryName,
        "category": {
          "uuid": this.state.categoryName,
        },
        "keywords": this.state.keywords?.length > 0 ? this.state.keywords.join(",") : "",
        "partners": this.state.partners,
      }
    };
    if (this.props.editData?.uuid) {

      updateSubCategoryApi(JSON.stringify(data), this.props.this, this.props.onHide, this.props.editData.uuid)
    } else {

      addSubCategoryApi(JSON.stringify(data), this.props.this, this.props.onHide);
    }

  };
  render() {
    const { AllCategeory, resLoading } = this.state;
    return (
      <CustomModal
        show={this.props.show}
        onHide={this.props.onHide}
        title={this.props.editData?.uuid ? "Edit Sub Category Master" : "Add Sub Category Master"}
        modalClass={"change-password"}
      >
        <Form onValidSubmit={this.onValidSubmit}>
          <Row>
              {isPartnerAllowed(this.state.AccessData?.id) &&
                  <Col md={12}>
                    <FormElement
                      valueLink={this.linkState(this, "partners.list")}
                      label="Publish To Partner(s)"
                      required
                      validations={[
                        {
                          validate: FormValidator.isRequired,
                          message: "Publish To cannot be empty",
                        },
                      ]}
                      control={{
                        type: SelectControl,
                        settings: {
                          options: this.state?.ssoPartnersOptions || [],
                          placeholder: "Select Partner(s)",
                          multiple: true,
                          searchable: true,
                          selectAll: true,
                          onChangeCallback: (onBlur) => {
                          },
                        },
                      }}
                    />

                  </Col>}
            <Col sm={12}>
              <FormElement
                valueLink={this.linkState(this, "subCategoryName")}
                label="Sub Category Name"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    //   type: "",
                    placeholder: "Enter Name",
                  },
                }}
              />
            </Col>
            <Col sm={12}>
              {/* {this.state.subCategoryName===""?null: */}
              <FormElement
                valueLink={this.linkState(this, "categoryName")}
                label="Select Category Name"
                required
                helpText=""
                hint={{
                  title: "Title Custom",
                  description: <span> Custom Hint Bro! </span>
                }}
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty"
                  }
                ]}
                control={{
                  type: SelectControl,
                  settings: {
                    options: AllCategeory.map((obj, index) => ({
                      value: obj.uuid,
                      label: obj.categoryName,
                    })),
                    multiple: false,
                    searchable: true,
                    // disabled:true,
                    onChangeCallback: (onBlur) => {
                      onBlur(this.state.categoryName);

                    }
                  }
                }}
              />
              {/* } */}
            </Col>
            <Col sm={12}>
              <SelectKeywords
                required={false}
                label="Keywords"
                placeholder={'Enter Keywords'}
                onchangeHandler={(data) => this.keywordsChangeHandler(data)}
                selectedKeyWords={this.state.keywords}
                options={this.state.keywordOption}
                getKeys={(data) => this.setState({ keywords: data })}
              />
            </Col>
          </Row>
          <div className="submit-wrapper" style={{ justifyContent: "center" }}>
            <FormSubmitButton customClass={"primary-btn"}>
              {resLoading ? <span className="d-flex align-items-center justify-content-center gap-12"> <Spinner /> Saving...</span> : "Save"}

            </FormSubmitButton>
          </div>
        </Form>
      </CustomModal>
    );
  }
}

export default connect(null, { getKeywordNameApi })(withRouter(ContentTypeForm));
